/* eslint-disable unicorn/filename-case -- TODO rename later */
import { FileRevision, FilterBy, JobStatusName } from "@istari/istari-client";

export const modelQueryKeys = {
  all: ["models"],
  item: (id: string) => [...modelQueryKeys.all, id],
  itemFull: (id: string) => [...modelQueryKeys.all, id, "full"],
  list: (filter: ListOptions) => [...modelQueryKeys.all, "list", filter],
  tasks: (modelId: string, filter: TaskListOptions) => [...modelQueryKeys.item(modelId), "tasks", filter],
  artifacts: (modelId: string, filter: ListOptions) => [...modelQueryKeys.item(modelId), "artifacts", filter],
  currentContent: (modelId: string) => [...modelQueryKeys.item(modelId), "currentContent"],
  content: (modelId: string) => [...modelQueryKeys.item(modelId), "content"],
  revisionContent: (modelId: string, revisionId: string) => [
    ...modelQueryKeys.item(modelId),
    "revisions",
    revisionId,
    "content",
  ],
  revision: (modelId: string, revisionId: string) => [...modelQueryKeys.item(modelId), "revisions", revisionId],
  allArtifacts: (modelId: string) => [...modelQueryKeys.item(modelId), "allArtifacts"],
  accessList: (modelId: string) => [...modelQueryKeys.item(modelId), "accessList"],
  artifactsProperties: (artifacts: FileRevision[]) => [...modelQueryKeys.all, "artifactsProperties", artifacts],
  fileRevisionContent: (sha: string, salt: string) => ["fileRevisionContent", sha, salt],
};

export interface ListOptions {
  size: number;
  page: number;
  sort: string | null;
  allUsers?: boolean;
  createdBy?: FilterBy | undefined | null;
}

export interface TaskListOptions extends ListOptions {
  statusName?: JobStatusName;
}
